import { render, staticRenderFns } from "./MealBtns.vue?vue&type=template&id=a95d42c0&"
import script from "./MealBtns.vue?vue&type=script&lang=js&"
export * from "./MealBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports